import getData from "@/__main__/get-data.mjs";
import ChampionsStatsModel from "@/feature-lol-rust-be/champion-aggregates-model.mjs";
import { API_V2_ROUTING } from "@/feature-lol-rust-be/constants.mjs";
import { QUEUE_SYMBOLS } from "@/game-lol/constants/constants.mjs";
import QueueSymbol, {
  getQueueDetails,
  QUEUE_SYMBOL_TO_OBJECT,
} from "@/game-lol/utils/symbol-queue.mjs";
import { getDerivedId, getDerivedQueue } from "@/game-lol/utils/util.mjs";

export default function ({
  region,
  gameName,
  tagLine,
  queue,
  path,
  options = {},
}: {
  region: string;
  gameName: string;
  tagLine: string;
  queue?: string;
  path?: string[];
  options: object;
}) {
  const p = (region || "").toUpperCase();
  const baseURL = API_V2_ROUTING[p] || API_V2_ROUTING["NA1"];
  const derivedId = getDerivedId(region, null, gameName, tagLine);

  let queueId = 0;

  if (queue) {
    const queueSymbol =
      QueueSymbol(queue) === QUEUE_SYMBOLS.custom
        ? QUEUE_SYMBOLS.rankedSoloDuo
        : QueueSymbol(queue);

    queueId =
      QUEUE_SYMBOL_TO_OBJECT[queueSymbol]?.id ||
      QUEUE_SYMBOL_TO_OBJECT[QUEUE_SYMBOLS.rankedSoloDuo].id;
  }

  return getData(
    `${baseURL}/lol/player_champion_aggregate/${p}/${gameName}/${tagLine}${queueId ? `/${queueId}` : ""}`,
    ChampionsStatsModel,
    path || [
      "lol",
      "playerChampionStats",
      getDerivedQueue(derivedId, getQueueDetails(queue).gql),
    ],
    {
      ...options,
    },
  );
}
